<div class="header" fxLayout="row" fxLayoutAlign="space-around center" >
    <div fxLayout="row" fxLayoutGap="30px">
        <img src="assets/img/logo_racc.svg" height="40px" alt="">
        <div>
            <div i18n> <mat-checkbox [(ngModel)]="showMap" (change)="cdRef.detectChanges()"></mat-checkbox> Incluir mapa grande</div> 
            <div class="subtitle" i18n>En cada punto de la ruta puedes obtener un mapa detallado</div>
        </div>
        
    </div>
    <div class="print-button" (click)="print()" i18n>
        Imprimir
    </div>
</div>

<div class="route-information" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span><img src="assets/img/distanceIcon.svg" alt="Icona cotxe"></span>
            <span *ngIf="!inrixFlag">{{getDistance()}}</span>
            <span *ngIf="inrixFlag && inrixData !== null">{{inrixData.distance}}</span>
        </span>
        <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span><img src="assets/img/timeIcon.svg" alt="Icona temps"></span>
            <span *ngIf="!inrixFlag">{{getDuration()}}</span>
            <span *ngIf="inrixFlag && inrixData !== null">{{inrixData.duration}}</span>
        </span>
        <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span><img src="assets/img/fuelIcon.svg" alt="Icona gasolina"></span>
            <span *ngIf="!inrixFlag">{{getFuel() | number}}€</span>
            <span *ngIf="inrixFlag && inrixData !== null">{{inrixData.fuel}}</span>
        </span>
</div>

<div class="map-container" [hidden]="!showMap">
    <div id="mapPrint" ></div>
</div>

<div class="details-container" *ngIf="!inrixFlag">
    <div *ngFor="let leg of route.legs; let iLeg = index">
        <div class="route-leg-title" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
            <div fxFlex="10%"><img src="{{urlImg + iconNames[iLeg]}}" width="30px" alt=""></div>
            <div fxLayout="column" fxLayoutAlign="start start">
                <div><b>{{leg.start_address}}</b></div>
                <div i18n>Aproximadamente <b>{{leg.duration.text}}</b></div>
            </div>
        </div>
        <div class="route-step" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngFor="let step of leg.steps; let iStep =index" >
            <div fxFlex="10%">
                {{iStep + 1 }}.
            </div>
            <div fxFlex="75%"  fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
                <div [innerHTML]="step.instructions"></div>
                <div class="show-map" (click)="toggleStepMap(iStep)" i18n>Mostrar mapa</div>
                <div *ngIf="stepVisible[iStep]"><img src="{{getStaticMapUrl(step)}}" alt=""></div>
            </div>
            <div fxFlex="15%" class="distance" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="center center" fxFlexAlign="center">
                <div>
                    {{step.distance.text}}
                </div> 
                <div *ngIf="step.maneuver !== '' && step.maneuver !== 'ramp'">
                    <img class="maneuver-icon" src="assets/img/maneuvers/{{step.maneuver}}.png">
                </div>
            </div>
    
        </div>
    </div>
    
    <div class="route-leg-title" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
        <div fxFlex="10%"><img src="{{urlImg + iconNames[route.legs.length]}}" width="30px" alt=""></div>
        <div fxLayout="column" fxLayoutAlign="start start">
            <div><b>{{route.legs[route.legs.length-1].end_address}}</b></div>  
        </div>
    </div>
</div>



    



